import { GlobeIcon, StarIcon } from "@heroicons/react/outline";
import { StarIcon as StarIconSolid } from "@heroicons/react/solid";
import { EllipsisVerticalIcon } from "lucide-react";

import LoadingSpinner from "@/components/LoadingSpinner";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuBasicTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

interface HistoryPageNavbarMenuProps {
  isLoggedIn: boolean;
  isLoadingToggleStarred: boolean;
  isStarred: boolean;
  onOpenShareDialog: () => void;
  onToggleStar: (value: boolean) => void;
}

const FavoriteMenuIcon = ({ isLoading, isStarred }: { isLoading: boolean; isStarred: boolean }) => {
  if (isLoading) {
    return <LoadingSpinner size={4} className="mr-2" />;
  }

  if (isStarred) {
    return <StarIconSolid className="mr-2 h-4 w-4 text-yellow-500" />;
  }

  return <StarIcon className="mr-2 h-4 w-4" />;
};

export const HistoryPageNavbarMenu = ({
  isLoggedIn,
  isLoadingToggleStarred,
  isStarred,
  onOpenShareDialog,
  onToggleStar,
}: HistoryPageNavbarMenuProps) => (
  <DropdownMenu>
    <DropdownMenuBasicTrigger asChild>
      <Button variant="ghost" size="sm" className="h-8 w-8 p-0 hover:bg-gray-100">
        <EllipsisVerticalIcon className="h-5 w-5" />
        <span className="sr-only">More actions</span>
      </Button>
    </DropdownMenuBasicTrigger>
    <DropdownMenuContent align="end" className="w-60">
      {isLoggedIn ? (
        <>
          <DropdownMenuItem
            onSelect={() => onToggleStar(!isStarred)}
            disabled={isLoadingToggleStarred}
            className="!w-full gap-2 whitespace-nowrap"
          >
            <FavoriteMenuIcon isLoading={isLoadingToggleStarred} isStarred={isStarred} />
            {isStarred ? "Remove Star" : "Star Request"}
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={onOpenShareDialog} className="!w-full gap-2">
            <GlobeIcon className="mr-2 h-4 w-4" />
            Share Settings
          </DropdownMenuItem>
        </>
      ) : null}
    </DropdownMenuContent>
  </DropdownMenu>
);
